import Vue from 'vue';
import axios from 'axios';

const defaultCommesse = [
  { id: "1", nome: "Commessa 1", codice: "Lotto 1" },
  { id: "2", nome: "Commessa 2", codice: "Lotto 2" }
];

const state = Vue.observable({
  commesse: defaultCommesse,
  activeCommessaId: localStorage.getItem('lotto') || "1",
  activeModules: [],
  selectedModuleId: localStorage.getItem('activeModuleId') || '',
  loadingCommesse: false,
  loadingModules: false
});

export const contextStore = {
  get state() {
    return state;
  },
  get activeCommessaId() {
    return state.activeCommessaId || "1";
  },
  get activeCommessa() {
    return state.commesse.find(c => String(c.id) === String(state.activeCommessaId)) || state.commesse[0] || null;
  },
  get commesse() {
    return state.commesse && state.commesse.length > 0 ? state.commesse : defaultCommesse;
  },
  get activeModules() {
    return state.activeModules;
  },
  get selectedModuleId() {
    return state.selectedModuleId;
  },
  get loadingCommesse() {
    return state.loadingCommesse;
  },
  get loadingModules() {
    return state.loadingModules;
  },

  async fetchCommesse() {
    const companyId = localStorage.getItem('fk_company');
    state.loadingCommesse = true;

    try {
      let list = [];
      if (companyId) {
        const res = await axios.get(`/companies/${companyId}/commesse`);
        list = Array.isArray(res.data) ? res.data : [];
      } else {
        // Se fk_company non è presente in localStorage, tentiamo una chiamata generica o usiamo le commesse di default
        try {
          const res = await axios.get(`/companies/1/commesse`);
          list = Array.isArray(res.data) ? res.data : [];
        } catch (e) {
          list = [];
        }
      }

      if (list.length > 0) {
        state.commesse = list;
        const savedLotto = localStorage.getItem('lotto');
        const exists = list.some(c => String(c.id) === String(savedLotto));
        if (savedLotto && exists) {
          state.activeCommessaId = String(savedLotto);
        } else {
          state.activeCommessaId = String(list[0].id);
          localStorage.setItem('lotto', state.activeCommessaId);
        }
      } else {
        state.commesse = defaultCommesse;
        if (!localStorage.getItem('lotto')) {
          localStorage.setItem('lotto', "1");
        }
        state.activeCommessaId = localStorage.getItem('lotto') || "1";
      }

      await this.fetchModules(state.activeCommessaId);
      return state.commesse;
    } catch (err) {
      console.error('Errore recupero commesse:', err);
      state.commesse = defaultCommesse;
      state.activeCommessaId = localStorage.getItem('lotto') || "1";
      return defaultCommesse;
    } finally {
      state.loadingCommesse = false;
    }
  },

  async setCommessa(commessaId) {
    if (!commessaId) return;
    const strId = String(commessaId);
    state.activeCommessaId = strId;
    localStorage.setItem('lotto', strId);
    await this.fetchModules(strId);
  },

  async fetchModules(commessaId) {
    const id = commessaId || state.activeCommessaId;
    if (!id) {
      state.activeModules = [];
      state.selectedModuleId = '';
      return [];
    }
    state.loadingModules = true;
    try {
      const res = await axios.get(`/commesse/${id}/modules`);
      const mods = Array.isArray(res.data) ? res.data : [];
      state.activeModules = mods;

      const savedModule = localStorage.getItem('activeModuleId');
      if (savedModule && mods.some(m => String(m.id) === String(savedModule))) {
        state.selectedModuleId = String(savedModule);
      } else {
        state.selectedModuleId = '';
        localStorage.removeItem('activeModuleId');
      }
      return mods;
    } catch (err) {
      console.error('Errore recupero moduli commessa:', err);
      state.activeModules = [];
      return [];
    } finally {
      state.loadingModules = false;
    }
  },

  setSelectedModule(moduleId) {
    const val = moduleId ? String(moduleId) : '';
    state.selectedModuleId = val;
    if (val) {
      localStorage.setItem('activeModuleId', val);
    } else {
      localStorage.removeItem('activeModuleId');
    }
  }
};
